import React from 'react';
import { Github, Linkedin, GraduationCap } from 'lucide-react';
import CompanyLogo from './CompanyLogos';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const AboutSection: React.FC = () => {


  const experiences = [
    {
      title: 'Staff Product Manager',
      company: 'Meta',
      period: '2025 - Present',
      description: 'Meta Ads | APIs | AI Models'
    },
    {
      title: 'Lead Product Manager',
      company: 'PromptQL',
      period: '2022 - 2024',
      description: 'API Platform | Accuracy in AI Models'
    },
    {
      title: 'Senior Product Manager',
      company: 'Imply',
      period: '2020 - 2022',
      description: 'Database'
    },
    {
      title: 'Product Delivery Manager',
      company: 'C3 AI',
      period: '2017 - 2020',
      description: 'AI Platform'
    },
    {
      title: 'Founder',
      company: 'Trialkings',
      period: '2015 - 2017',
      description: 'An online rental marketplace'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-beige-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="pt-8">
            <div className="text-xl font-math text-beige-600 leading-relaxed">
              Impact = ∫<sub className="align-sub text-s">t=0</sub><sup className="align-super text-xs">15</sup> (∇P<sub className="align-sub text-sm">problem breakdown</sub> →<sup className="align-super text-xs">MVP</sup> ΣS<sub className="align-sub text-xs">scaled solution</sub>) ⋅ XFN<sub className="align-sub text-xs">Eng, DS, Design, Sales</sub> dt
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* About Me */}
          <div>
            <h2 className="text-3xl font-light text-gray-900 mb-6 flex items-center">
              <span className="font-math mr-3">∫</span>
              About Me
            </h2>
            <div className="bg-white rounded-lg shadow-sm p-6 border border-beige-200">

              {/* Mathematical Equation Section */}
              <div className="mt-6 p-4 bg-beige-50 rounded-lg border border-beige-200">
                <h3 className="text-lg font-medium text-gray-900 mb-3 font-math">
                  15 Years of Product Impact
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm mb-3">
                  Over 15 years, I've learnt the art of breaking down complex problems (∇P<sub>problem breakdown</sub>) 
                  into manageable components, shipping rapid MVP, and then scaling MVP solutions (ΣS<sub>scaled solution</sub>) 
                  to serve larger audiences.
                </p>
                <p className="text-gray-700 leading-relaxed text-sm mb-3">
                  This requires close collaboration with cross-functional partners (XFN) - 
                  building products with Engineering, defining UX with Design, learning usage patterns with Data Science, and listening to sales for customer insights. 
                </p>
              </div>

              {/* Education Section */}
              <div className="mt-6 p-4 bg-beige-50 rounded-lg border border-beige-200">
                <h3 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
                  <GraduationCap size={20} className="mr-2 text-beige-600" />
                  Education
                </h3>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium text-gray-900">MIT Sloan School of Management</h4>
                    <p className="text-sm text-gray-600">Master of Business Administration (MBA)</p>
                    <p className="text-sm text-beige-600">2016 - 2017</p>
                  </div>
                  <CompanyLogo company="MIT" className="w-16 h-16" />
                </div>
              </div>
              

              {/* Social Links */}
              <div className="flex space-x-4 mt-6">
                <a href="https://github.com/amit-git-account" className="text-gray-800 hover:text-gray-600 transition-colors">
                  <Github size={20} />
                </a>
                <a href="https://linkedin.com/in/amit-tomar" className="text-blue-600 hover:text-blue-700 transition-colors">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>

          {/* Experience */}
          <div>
            <h2 className="text-3xl font-light text-gray-900 mb-6 flex items-center">
              <span className="font-math mr-3">∑</span>
              Experience
            </h2>

            {/* Experience */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-beige-200">
              
              <div className="space-y-4">
                {experiences.map((exp, index) => (
                  <div key={index} className="border-l-2 border-beige-300 pl-4">
                    <div className="flex items-start justify-between mb-2">
                      <div className="flex-1">
                        <h4 className="font-medium text-gray-900">{exp.title}</h4>
                        <p className="text-beige-600 text-sm">{exp.company}</p>
                        <p className="text-gray-500 text-sm">{exp.period}</p>
                      </div>
                      <div className="ml-4 flex items-center justify-center">
                        <CompanyLogo company={exp.company} />
                      </div>
                    </div>
                    <p className="text-gray-700 text-sm">{exp.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
